<template>
  <div>
    <q-layout view="lHh Lpr lFf" v-if="!home">
      <!-- Init & Login screen -->
      <div class="window-height row justify-center items-center text-center q-mx-auto">
        <div class="col-9 col-md-3">
          <div class="row justify-center items-center text-center q-pa-md">
            <img alt="logo" :src="myimg" href="/index" style="max-height:300px;min-width:auto;max-width:60vw;">
          </div>
          <div class="row justify-center items-center text-center">
            <div class="col-12">
              <q-card-section>
                <div v-if="isAnonymous">
                  <q-input class="q-my-xs" v-model="id" placeholder="Nhập tên đăng nhập hoặc email">
                    <template v-slot:prepend>
                      <q-icon name="account_circle" />
                    </template>
                  </q-input>
                  <q-input class="q-my-xs" placeholder="Mật khẩu" v-model="password" :type="isPwd ? 'password' : 'text'"
                    v-on:keyup.enter="login()">
                    <template v-slot:prepend>
                      <q-icon name="lock" />
                    </template>
                    <template v-slot:append>
                      <q-icon :name="isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer"
                        @click="isPwd = !isPwd" />
                    </template>
                  </q-input>
                  <div class="column">
                    <q-btn ripple class="text-red-4 q-mt-md col" @click="login()" :outline="isAnonymous"
                      :flat="!isAnonymous" :loading="loading">
                      <q-icon name="home" left class="q-mr-sm"></q-icon>Đăng nhập
                    </q-btn>
                    <!-- <q-btn ripple class="text-red-6 q-mt-md col" @click="loginNafoods()" :outline="isAnonymous"
                      :flat="!isAnonymous" :loading="loading || !isAnonymous">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px"
                        viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                        <image id="image0" width="16" height="16" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQEAYAAABPYyMiAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
                          AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0T///////8JWPfcAAAA
                          B3RJTUUH4woKDBo5nzuw/gAABbtJREFUSMfFlG1QlOcZha/n3c0uy66iglr5VBEXOyFghBgh6JhY
                          JYk4sjFqoE2pdtIYpBlTaatimRhDE6VORqNJI44fFSo0sCFGG2xxlSiIFhFdFbIChoSCBFZgl69d
                          3n36w5lOZjqpP3N+33Pmus+cOfADSzzsoKjIarVYAIVuFH0ILlGAa9YVethHjyNV7CSPnXKmdMoK
                          nOZLDFLFoKMQBX+U0WUZE9PSyn/5/f7KQxFHUBkBWrhHi6GS1QSxequGdNaR/lSNvEMHdxbkiXCR
                          QnjuKgStCGMVOkbRPTwB7fd+/CCgG+IAYRyQMbIKQdWPpokMykRG4jV5UH4lD17oQgNovJIkkUnS
                          gsP4yOFWcK5IEPNJcFJUYLVaFoicB35yd8bmtLTy2v8DwGxmMRtwM4g7crw8ipajgavxiEymxL7L
                          LLKY5R8jwkQIYfZr6NGh924jiyzxqH67iBBhcs+it2SdrKHUH3w4WdpjRIcRXStsBr4D8D8dKE7+
                          5CeWbqCNZtoWziaAFALejOMOblqGNhDLMLETgmS2tJC9PJNRtIz6jKJMlFP+acsDR08wU5gkJmtz
                          cHBeOrbZCSZKBNfsSP/bypNlvu90oHiedb/lLq8X3bTWW3b4nx4W7qFhwWOygX4aHu8mGJXgGTPl
                          DbmbK19uki8wxHFb5MhaU6oS35f5WJ/t5YGC/mqZRD97z9rkPrmL3Y7NDOFmKHILjfIqjXFLtfna
                          Nm0+FJ2yWi3rDL8qPmstfSGLeI0ldO2m6DeoI5ZBYX0xULtEl/bIhehYESc8xFns9NFLv/MO1SIC
                          3Zb741b07vYu91RMz2/wDa3p/Jnvovhc1msOeY/5u5VY5fnRWqNNc61ishjDTnVyLU+JXSIp1KRG
                          qx+r0d5T9OKhd84YLibgurlX604ZaRhMYdm4HX4bTZXzBlDFetS5Lkx4aQn4nbxJOfayezMe+afP
                          deab/Kkl1w8PN8Yf1J4YLPTVpQ8RKi8xoH4wqe/SkpHcvm/vZ0Tl6T/8altzRWp1QGW1VawUi2V3
                          apzYIn6BK7sAr6zBW3dfE6h8qwksRTHl+TlNeYE/Zq54WsxN2IOHTkbbPpTF8m1KCrPZSjqdtw4f
                          ubvPOmc96M72FKrGpOtK+nCqbH/1WWXRSJfUvNqiK+z9TN2V/Er8qUMlbyQDO8UGPPZ4zsv3+eKI
                          lS6S6Po6Br2woH+ieczfl6P6TzQpwsAG9JHXaSGSngizPEIXdedyxWus4srxYmP3QOrY/J6Pf5+Z
                          eL6+euYxYshj4dJm/AhFU9fKvzDhrTvAEH4oS3ytmsSQ/G1Re/xbXFvV7d0G6eA4acdyZAW13DzX
                          hR+BYvLMCxwTxRyZLhR5jwmY+/uplGdkVtMKzYmxL6ShqSi4o1EdTHb91Lzxk4N9qqxULnoypWFN
                          GMlomDjeRRN2Skp/TQS3aS6BWKYwwz9bueuJk50vrTH/ucLXFzAWMS3dfnfo0wFV877aLpff/ou4
                          Ia/L0i+b8fBzEtw+TXjQ0U2JCb2V0Z9dbnWFty0O3XLVPDhqPDS91/qea524pHM4V/mmb/xc2Ttm
                          xPiklyp6OHXbIU9j4+RfHWI9HXh6CjhBLScffU45q5p4et40fUePU90ZtDho9bXukZJbI4rP+Iw4
                          NLXSO970rOYftpX1ccvqJ15tuKwpfK3zTMDf+cD7emKNtvnr3JA/FIe6nQazWDTagpJzWgj5Hk+8
                          WIALP9ps78rf8g5/PJyAFpgad5pN9HF/RhQv00HruXfEv3mFtOBQkklnzksn5UJNnSibNNkgezVj
                          zirrsO+ZC/rR+osL1u4f7n6THf8dovb2Oe1P9oP8k1qhVmBW9mutWmtwCjHMZ37MR9KGDVvjW9jp
                          outeFeGMY1yIA1BR2U4HHXR0XMFMFOaQpSKJ50h63E4TMTRdTfY1eVfIpm9+IwxatzBwOTz8dmBt
                          LT+8/gOkeY8hRpnYvQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOS0xMC0xMFQxOToyNjo1Ny0wNzow
                          ML/yJFwAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTktMTAtMTBUMTk6MjY6NTctMDc6MDDOr5zgAAAA
                          AElFTkSuQmCC" />
                      </svg> Đăng nhập bằng mail Nafoods
                    </q-btn> -->
                    <q-btn flat color="primary" @click="promptResetPass = true" label="Quên mật khẩu" class="col" />
                    <q-dialog v-model="promptResetPass" persistent>
                      <q-card style="min-width: 400px">
                        <q-card-section>
                          <div class="text-h6">Nhập email của bạn</div>
                        </q-card-section>

                        <q-card-section>
                          <q-input type="email" label="Email" clearable dense v-model="emailResetPass" autofocus @keyup.enter="promptResetPass = false" />
                        </q-card-section>

                        <q-card-actions align="right">
                          <q-btn flat icon="clear" v-close-popup />
                          <q-btn flat @click="resetPass" v-close-popup>
                            <q-icon v-show="!isEmailResetSending" name='check' style="font-size:2em"></q-icon>
                            <q-spinner-tail v-show="isEmailResetSending" color="blue-grey" />
                          </q-btn>
                        </q-card-actions>
                      </q-card>
                    </q-dialog>
                  </div>
                </div>
                <q-inner-loading :showing="!isAnonymous">
                  <q-spinner-tail size="150px" class="text-red-4" style="margin: -15px 0" />
                </q-inner-loading>
              </q-card-section>
            </div>
          </div>
        </div>
      </div>
    </q-layout>
    <template v-else>
      <q-layout view="lHh Lpr lFf">
        <q-header reveal elevated class="bg-white shadow-2" style="width: 100%">
          <q-toolbar>
            <q-toolbar-title>
              <router-link to="/">
                <q-img
                  class=""
                  :src="myhor"
                  spinner-color="white"
                  style="height: 100%; max-width: 150px"
                />
              </router-link>
            </q-toolbar-title>
            <div>
              <q-btn color="grey" flat dense round @click="leftDrawerOpen = !leftDrawerOpen" aria-label="Menu" icon="menu" />
            </div>
          </q-toolbar>
        </q-header>
        <q-drawer v-model="leftDrawerOpen" bordered content-class="bg-grey-2" side="right" >
          <q-img class="absolute-top" :src="backgr" style="height: 200px; margin-top:-50px">
            <div class="absolute-bottom bg-transparent">
              <q-avatar size="56px" class="q-mb-sm">
                <img :src="user.photoURL ? user.photoURL : myimg">
              </q-avatar>
              <div class="text-weight-bold">{{user.displayName ? user.displayName : user.email}}</div>
            </div>
          </q-img>
          <q-scroll-area style="height: calc(100% - 150px); margin-top: 150px; border-right: 1px solid #ddd">
            <q-list padding>
              <q-item v-for="(item) in menu" clickable q-ripple :key="item.title" :to="item.route" v-show="item.show">
                <q-item-section avatar>
                  <q-icon :name="item.icon" />
                </q-item-section>
                <q-item-section>{{item.title}}</q-item-section>
              </q-item>
              <!-- <q-item clickable q-ripple @click="openURL()('https://docs.google.com/document/d/1PKhS9HlUQtHaKVWrOCLup99TB73AOVJI5ieI3M0PYok/edit')">
                <q-item-section avatar>
                  <q-icon name="fas fa-question-circle" />
                </q-item-section>
                <q-item-section > 
                  <span href="https://docs.google.com/document/d/1PKhS9HlUQtHaKVWrOCLup99TB73AOVJI5ieI3M0PYok/edit#"> HDSD </span>
                  </q-item-section>
              </q-item> -->
              <q-item clickable q-ripple @click="$auth.logout">
                <q-item-section avatar>
                  <q-icon name="power_settings_new" />
                </q-item-section>
                <q-item-section>Đăng xuất</q-item-section>
              </q-item>
            </q-list>
          </q-scroll-area>
          
        </q-drawer>
        <q-page-container>
          <q-page style="padding-top: 20px" class="q-pa-md">
            <router-view :key="keyRouterView"></router-view>
            <!-- scrolltotop -->
            <q-page-scroller position="bottom-right" :scroll-offset="150" :offset="[18, 18]">
              <q-btn size="md" unelevated round icon="keyboard_arrow_up" color="primary" />
            </q-page-scroller>
          </q-page>
        </q-page-container>
      </q-layout>
    </template>
    <!-- diaglog update -->
    <q-dialog v-model="newContentDiaglog" position="bottom" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <span class="col-10 q-pl-sm">Có phiên bản mới vui lòng làm mới trang</span>
          <q-btn flat class="col-2" icon="fas fa-sync" @click="reloadPage" color="green" />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import backgr from '@/assets/bg.png'
import myimg from '@/assets/logo.png'
import myhor from '@/assets/logo_hor.png'
import { checkPermission } from "naf-acl";
import { mapGetters } from 'vuex'
import { openURL } from 'quasar'
import EventBus from '@/EventBus'

const MENU = [
  // { route: '/plans', title: 'Kế hoạch', icon: 'assignment', show: true },
  // { route: '/statistics', title: 'Báo cáo', icon: 'trending_up', show: true },
  // { route: '/timekeeping', title: 'Chấm công', icon: 'assignment_ind', show: true },
  // { route: '/tasks', title: 'Thực hiện công việc', icon: 'assessment', show: true },
  // { route: '/task-management', title: 'Quản lý công việc', icon: 'fas fa-chalkboard-teacher', show: true },
  {
    route: '/human-resources', title: 'Nhân sự', icon: 'account_box',
    notComputeShow: true,
    show: "vm.showHR",
    group: ["admin", "bom", "hr"]
  },
  // { route: '/categories', title: 'Danh mục', icon: 'category', show: true },
  {
    route: "/meeting-minutes",
    title: "Biên bản cuộc họp",
    icon: "fas fa-clock",
    show: false,
    group: ["admin", "bom", "logged"]
  },
]

export default {
  data () {
    return {
      password: '',
      loading: false,
      isPwd: true,
      id: '',
      pass: '',
      leftDrawerOpen: false,
      menu: null,
      myimg: myimg,
      myhor: myhor,
      keyRouterView: 1,
      backgr: backgr,
      promptResetPass: false,
      emailResetPass: '',
      isEmailResetSending: false,
      newContentDiaglog: false,
      worker: null,
      refreshing: false
    }
  },
  async created() {
    let vm = this
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if(vm.refreshing) return;
      window.location.reload();
      vm.refreshing = true
    })
    document.addEventListener('swUpdated', (reg) => {
      this.worker = reg.detail.waiting
      this.newContentDiaglog = true
      }, { once: true })
      window.addEventListener("load", () => {
        function handleNetworkChange(event) {
          if (!navigator.onLine) {
            vm.$q.notify({
              message: vm.$DIC.CONNECTION_ERROR,
              color: 'red',
              icon: 'error',
              timeout: 15000
            })
          }
        }
        window.addEventListener("online", handleNetworkChange);
        window.addEventListener("offline", handleNetworkChange);
      })
      if (this.user) {
      this.menu = MENU;
      this.checkModulesPermission();
    } else {
      this.menu = null;
    }
      EventBus.$on('reloadPage', this.refresh)
    },
  mounted() {
    },
  computed: {
    home () {
      return this.user && this.menu
    },
    showHR() {
      if (this.$store.getters.permission) {
        let groups = this.R.path(["groups"], this.$store.getters.permission);
        let level = this.R.path(
          ["level", "value"],
          this.$store.getters.permission
        );
        let dep = this.R.path(["dep", "id"], this.$store.getters.permission);
        let title =
          this.R.path(["title"], this.$store.getters.permission) || "";
        return (
          this.R.includes("admin", groups) ||
          this.R.includes("bom", groups) ||
          this.R.includes(level, ["bom", "manager", "lead", "assistant"]) ||
          (dep === "HR" &&
            (title.trim().toLowerCase() === "nhân viên nhân sự" ||
              title.trim().toLowerCase() === "chuyên viên nhân sự"))
        );
      }
      return false;
    },
    ...mapGetters([
      'isAnonymous','user', 'permission'
    ])
  },
  watch: {
    user: function(newValue) {
      if (newValue) {
        this.menu = MENU;
        this.checkModulesPermission();
      } else {
        this.menu = null;
      }
    },
    permission: function(newValue) {
      if (newValue && this.user) {
        this.checkModulesPermission();
      }
    }
  },
  methods: {
    reloadPage() {
      this.worker.postMessage( { action: 'skipWaiting' })
    },
    async login() {
      let vm = this
      vm.loading = true
      await vm.$auth.login(vm.id, vm.password).catch(error => {
        vm.$q.notify({
          message: `${error}`,
          color: 'red',
          icon: 'error'
        })
      vm.loading = false
      })
    },
    async loginNafoods() {
      let vm = this
      vm.loading = true
      await vm.$auth.loginNafoods().catch(error => {
        vm.$q.notify({
          message: `${error}`,
          color: 'red',
          icon: 'error'
        })
      vm.loading = false
      })
      vm.loading = false
    },
    openURL() {
      return openURL
    },
    async refresh (done) {
      try {
        this.keyRouterView++
      }
      catch (error) {
        console.log(error)
      }
    },
    runScript(e) {
      if (e && (event.which == 13 || e.keyCode == 13)) {
        this.login()
      }
    },
    async resetPass() {
      this.isEmailResetSending = true
      await this.$auth.resetPass(this.emailResetPass).then(() => {
        this.isEmailResetSending = false
        this.$q.notify({
          message: 'Email khôi phục mật khẩu đã được gửi về email của bạn',
          color: 'black',
          icon: 'check'
        })
      }).catch(err => {
        this.$q.notify({
          message: `${err}`,
          color: 'red',
          icon: 'check'
        })
        this.isEmailResetSending = false
      })
    },
    checkModulesPermission() {
      let vm = this;
      if (!vm.user || !vm.menu) return;
      vm.menu.forEach(item => {
        if (!item.notComputeShow) {
          item.show = vm.checkPermission(item.group);
        } else {
          item.show = eval(item.show);
        }
      });
    },
    checkPermission
  }
}
</script>

<style>
.q-drawer {
  position: fixed !important
}
</style>
